import { Injectable, RendererFactory2 } from '@angular/core'
import { Meta } from '@angular/platform-browser'
import { WindowRef } from '@spartacus/core'
import { PageMetaLinkService } from '@spartacus/storefront'
import {
  EbAlternateLink,
  EBOGPMetaData,
  EBStructuredProductData
} from '../cms/interfaces/eb-page.interface'
import { EbBaseSiteService } from '../site-context/services/eb-base-site.service'

@Injectable({
  providedIn: 'root'
})
export class EbPageMetaLinkService extends PageMetaLinkService {
  constructor(
    protected winRef: WindowRef,
    protected rendererFactory: RendererFactory2,
    protected baseSiteService: EbBaseSiteService,
    protected meta: Meta
  ) {
    super(winRef, rendererFactory)
  }

  setAlternateLinks(alternates: EbAlternateLink[]): void {
    const alternateLinks = Array.from(
      this.winRef.document.querySelectorAll('link[rel="alternate"]') as NodeListOf<HTMLLinkElement>
    )
    if (alternates && alternates.length > 0) {
      alternates.forEach(alternate => {
        let link
        link = alternateLinks.find(existingLink => existingLink.hreflang === alternate.hrefLang)
        if (link) {
          link.setAttribute('href', alternate.url)
        } else {
          link = this.renderer.createElement('link')
          link.rel = 'alternate'
          link.href = alternate.url
          link.hreflang = alternate.hrefLang
          this.renderer.appendChild(this.winRef.document.head, link)
        }
      })
    } else {
      alternateLinks.forEach(link => link.remove())
    }
  }

  setStructuredProductMetaData(structuredData: EBStructuredProductData): void {
    const jsonldScripts = Array.from(
      this.winRef.document.querySelectorAll(
        'script[type="application/ld+json"]'
      ) as NodeListOf<HTMLLinkElement>
    )
    if (structuredData) {
      if (jsonldScripts.length > 0) {
        jsonldScripts[0].textContent = JSON.stringify(structuredData)
      } else {
        const jsonldScript = this.renderer.createElement('script')
        jsonldScript.type = 'application/ld+json'
        jsonldScript.textContent = JSON.stringify(structuredData)
        this.renderer.appendChild(this.winRef.document.head, jsonldScript)
      }
    } else {
      jsonldScripts.forEach(script => script.remove())
    }
  }

  setOGPMetaData(metaData: EBOGPMetaData): void {
    const openGraphTags = Array.from(this.winRef.document.querySelectorAll('meta[id="ogp"]'))
    if (metaData) {
      if (openGraphTags.length > 0) {
        Object.entries(metaData).forEach(metaDataAttribute => {
          this.updateOGPTag(metaDataAttribute)
          if (metaDataAttribute[0] === 'image') {
            metaDataAttribute[0] = 'image:secure_url'
            this.updateOGPTag(metaDataAttribute)
          }
        })
      } else {
        Object.entries(metaData).forEach(metaDataAttribute => {
          this.addOGPTag(metaDataAttribute)
          if (metaDataAttribute[0] === 'image') {
            metaDataAttribute[0] = 'image:secure_url'
            this.addOGPTag(metaDataAttribute)
          }
        })
      }
    }
  }

  private addOGPTag(metaDataAttribute) {
    this.meta.addTag({
      id: 'ogp',
      property: `og:${metaDataAttribute[0]}`,
      content: metaDataAttribute[1]
    })
  }

  private updateOGPTag(metaDataAttribute) {
    this.meta.updateTag({
      id: 'ogp',
      property: `og:${metaDataAttribute[0]}`,
      content: metaDataAttribute[1]
    })
  }
}
